import { useContext, useMemo } from 'react';
import { useLocale } from 'next-intl';

import Placeholder from '@guestyci/foundation/Placeholder';
import useFeatureToggle from '@guestyci/feature-toggle-fe/useFeatureToggle';

import { useGetCurrencyRateQuery } from 'hooks/useGetCurrencyRate';
import { getPriceStr } from 'utils';
import { CurrencyContext } from 'context/CurrencyContext';
import { DISCO_BE_PRICE_FORMAT } from 'constants/featureToggleNames';

const PriceConverter = ({ currency, amount, roundPrice = 0 }) => {
  const { selectedCurrency } = useContext(CurrencyContext);
  const [, isPriceFormatEnabled] = useFeatureToggle(DISCO_BE_PRICE_FORMAT);
  const locale = useLocale();
  const { data, status, isLoading, isSuccess } = useGetCurrencyRateQuery({ from: currency, to: selectedCurrency });
  const calculatedAmount = isSuccess ? (data?.rate || 1) * amount : amount;
  const price = useMemo(() => {
    const roundedPrice = roundPrice ? calculatedAmount?.toFixed(roundPrice) : Math.round(calculatedAmount);
    return getPriceStr({ price: roundedPrice, currency: selectedCurrency, locale, isPriceFormatEnabled });
  }, [calculatedAmount, selectedCurrency, roundPrice, locale, isPriceFormatEnabled]);

  if (status === 'loading' || isLoading) {
    <Placeholder className="cell-placeholder height-10 w-fill" />
  }

  return <span data-qa="price-converter">{price}</span>;
};

export default PriceConverter;
